const topics = [
  { tag: '#科幻电影', count: '3.2万讨论', hot: true },
  { tag: '#悬疑剧推荐', count: '2.8万讨论', hot: true },
  { tag: '#国漫崛起', count: '2.5万讨论', hot: true },
  { tag: '#综艺名场面', count: '2.1万讨论', hot: false },
  { tag: '#经典港片', count: '1.9万讨论', hot: false },
  { tag: '#暑期档', count: '1.7万讨论', hot: true },
  { tag: '#治愈系动漫', count: '1.5万讨论', hot: false },
  { tag: '#高分美剧', count: '1.3万讨论', hot: false },
  { tag: '#纪录片', count: '1.1万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          大家都在讨论的影视话题，加入观影交流
        </p>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((t, i) => (
            <div
              key={i}
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              {t.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {t.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{t.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}